import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "45.487",
  width: "50",
  viewBox: "0 0 50 45.487",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M12.673 0v5.76h3.646V0h-3.65zm22.135 0v5.76h3.646V0h-3.646zM-.002 7.466v38.02h50V7.466H0zm3.647 3.646h7.812v7.812H3.645v-7.812zm11.458 0h8.333v7.812h-8.333v-7.812zm11.98 0h7.81v7.812h-7.81v-7.812zm11.457 0h7.812v7.812H38.54v-7.812zM3.644 22.57h7.812v8.333H3.644V22.57zm11.458 0h8.333v8.333h-8.333V22.57zm11.98 0h7.81v8.333h-7.81V22.57zm11.457 0h7.81v8.333h-7.81V22.57zM3.643 34.54h7.812v7.29h-7.81v-7.29zm11.458 0h8.333v7.29h-8.333v-7.29zm11.98 0h7.81v7.29h-7.81v-7.29zm11.457 0h7.812v7.29H38.54v-7.29z"
  })]
});